import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";

interface Advertisement {
  id: string;
  title: string;
  description: string;
  image: string;
  link: string;
  sponsor: string;
}

export default function SponsoredSlider() {
  const [current, setCurrent] = useState(0);

  const advertisements: Advertisement[] = [
    {
      id: '1',
      title: "Je télécharge l'application suñuy Artisan",
      description:
        "Avec Suñuy Artisan, nous digitalisons l'artisanat, facilitons l'accès aux marchés publics et renforçons la compétitivité des artisans.",
      image: "/logo/logo-sunuy-art.png",
      link: "https://sunuyartisan.pmn.sn/",
      sponsor: "Suñuy Artisan",
    },
    {
      id: '2',
      title: "Ministère du Tourisme et de l'Artisanat",
      description:
        "Partenariat entre le PMN et l'ARCOP pour faciliter aux artisans l'accès à la commande publique.",
      image: "/logo/logo-tourisme.png",
      link: "https://tourisme.gouv.sn/partenariat-entre-le-pmn-et-larcop-pour-faciliter-aux-artisans-lacces-a-la-commande-publique/",
      sponsor: "Ministère",
    },
    
  ];

  // Auto-défilement toutes les 5 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % advertisements.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [advertisements.length]);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % advertisements.length);
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? advertisements.length - 1 : prev - 1
    );
  };

  return (
    <div className="w-full bg-gradient-to-r from-orange-50 to-white border rounded-xl shadow-sm py-2 px-4 flex flex-col md:flex-row items-start md:items-center gap-4 relative">
      {/* Badge Sponsorisé */}
      <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 rounded-md font-semibold text-sm flex-shrink-0">
        À la une
      </div>

      {/* Pub en cours */}
      <div className="flex items-center gap-4 flex-1 w-full md:w-auto">
        <img
          src={advertisements[current].image}
          alt={advertisements[current].title}
          className="w-10 h-10 md:w-12 md:h-12 object-contain rounded-md border flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <h4 className="font-bold text-sm md:text-base text-gray-900 line-clamp-1">
            {advertisements[current].title}
          </h4>
          <p className="text-sm text-gray-600 line-clamp-2 md:line-clamp-1">
            {advertisements[current].description}
          </p>
        </div>
        
        {/* Bouton ExternalLink */}
        <a
          href={advertisements[current].link}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-blue-50 hover:bg-blue-100 text-blue-500 transition-colors duration-200 flex-shrink-0 ml-auto"
          aria-label="Ouvrir le lien dans un nouvel onglet"
        >
          <ExternalLink className="w-4 h-4 md:w-5 md:h-5" />
        </a>
      </div>

      {/* Navigation (seulement flèches et compteur) */}
      <div className="flex items-center gap-2 self-end md:self-center">
        <button
          onClick={prevSlide}
          className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-white shadow hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
          aria-label="Publicité précédente"
        >
          <ChevronLeft className="w-3 h-3 md:w-4 md:h-4" />
        </button>
        <button
          onClick={nextSlide}
          className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-white shadow hover:bg-gray-100 flex items-center justify-center transition-colors duration-200"
          aria-label="Publicité suivante"
        >
          <ChevronRight className="w-3 h-3 md:w-4 md:h-4" />
        </button>
        <span className="text-xs text-gray-500 font-medium">
          {current + 1} / {advertisements.length}
        </span>
      </div>
    </div>
  );
}